import {Paper} from '@material-ui/core';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import useLoadKPI from '../requests/kpi/useLoadKPI';
import {createStyles, makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    colorButton: {
      paddingTop: '1px',
      paddingBottom: '1px',
      textAlign: 'center',
    },
  }),
);

export const lookupStatus = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Sin empezar')},
      {id: 1, name: i18n2._('Terminado')},
      {id: 2, name: i18n2._('En Progreso')},
      {id: 4, name: i18n2._('Suspendido')},
    ],
    key: 'id',
  },
};

export const lookupOnTime = {
  store: {
    type: 'array',
    data: [
      {id: 'onTime', name: '> 15 días'},
      {id: 'nearDueDate', name: '> 7 y ≤ 15 días'},
      {id: 'almostDueDate', name: '> 1 y ≤ 7 días'},
      {id: 'dued', name: '≤ 0 días (VENCIDAS)'},
    ],
    key: 'id',
  },
};

export const OnTime = ({text}) => {
  const classes = useStyles();
  switch (text) {
    case 'onTime':
      return (
        <Paper
          className={`white-text ${classes.colorButton}`}
          style={{backgroundColor: '#00B050'}}>
          {i18n2._(text)}
        </Paper>
      );
    case 'nearDueDate':
      return (
        <Paper
          className={`white-text ${classes.colorButton}`}
          style={{backgroundColor: '#80a352'}}>
          {i18n2._(text)}
        </Paper>
      );
    case 'almostDueDate':
      return (
        <Paper
          className={`yellow-background white-text ${classes.colorButton}`}
          style={{backgroundColor: '#FFFF00'}}>
          {i18n2._(text)}
        </Paper>
      );
    case 'dued':
      return (
        <Paper
          className={`red-background white-text ${classes.colorButton}`}
          style={{backgroundColor: '#FF0000'}}>
          {i18n2._(text)}
        </Paper>
      );
    default:
      return <Paper></Paper>;
  }
};

const KPIGrid = ({filters, pendingOnly = false, isKPIView = false}) => {
  const loadKPI = useLoadKPI({pendingOnly});

  return (
    <IntegrityRoleGrid
      dataSource={loadKPI}
      disabledExport={true}
      autoWidth={false}
      id={['iD_Course']}
      defaultFilterValue={filters}
      shouldSaveOnlyFilters={true}
      height={'100%'}
      allowIntegrity={false}
      allowActions={false}>
      <Column caption={i18n2._('#Course')} dataField="iD_Course" />
      <Column caption={i18n2._('Documento')} dataField="doc_Number" />
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column caption={i18n2._('Nombre')} dataField="nameCollab" />
      <Column caption={i18n2._('Nombre sector')} dataField="nameSector" />
      <Column caption={i18n2._('Perfil')} dataField="nameProfile" />
      <Column caption={i18n2._('Nombre Curso')} dataField="nameCourse" />
      <Column
        caption={i18n2._('Vencimiento de la instancia')}
        dataField="expiration_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row) => new Date(row.expiration_Date)}
      />
      <Column
        caption={i18n2._('Fecha de instancia')}
        dataField="instance_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row) => new Date(row.instance_Date)}
      />
      <Column
        caption={i18n2._('Fecha de realizacion')}
        dataField="finishedDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row) =>
          row.status === 1 ? new Date(row.finishedDate) : null
        }
      />
      <Column caption={i18n2._('Categoria')} dataField="category" />
      <Column
        caption={i18n2._('En tiempo')}
        dataField="onTimeReport"
        cellComponent={(props) => <OnTime text={props.data.value} />}>
        <Lookup dataSource={lookupOnTime} valueExpr="id" displayExpr="name" />
      </Column>
      <Column caption={i18n2._('Turno')} dataField="shift_Name" />

      <Column caption={i18n2._('Estado')} dataField="status">
        <Lookup dataSource={lookupStatus} valueExpr="id" displayExpr="name" />
      </Column>
      {/* <Column caption={i18n2._('Timeliness of implementation')} dataField="onTimeAgainAskCris" /> */}
      {/* <Column caption={i18n2._('Days Overdue')} dataField="daysOverdue" /> */}
      <Column
        caption={i18n2._('OnTime')}
        dataField="onTime"
        calculateCellValue={(row) => (row.status === 1 ? row.onTime : null)}
        visible={!isKPIView}
      />
      <Column caption={i18n2._('#Turno')} dataField="iD_Shift" visible={false} />
      <Column caption={i18n2._('Activo')} dataField="active" visible={false} />
    </IntegrityRoleGrid>
  );
};

export default KPIGrid;
